import React from 'react';
import Root from 'cont/Root';
import Expo from 'expo';
import { Platform, I18nManager } from 'react-native';
import { FAV_ICON } from 'constants';
import registerServiceWorker from 'serviceworker';
import configureStore from './store/configureStore';
import { setDefaultLang, lang } from 'lang';
import { LoadAssets } from 'icons/icon';

const store = configureStore();

if (Platform.OS === 'web') {
  registerServiceWorker();
  const { render } = require('react-dom');
  document.title = lang.FOSOL;
  document.getElementById('fosol-fav-icon').href = FAV_ICON;
  render(<Root store={store} />, document.getElementById('root'));
  if (module.hot) {
    console.log('Connected');
    module.hot.accept('./containers/Root', () => {
      const Root = require('cont/Root').default;
      console.log(`%c ==========  Recived update in ${Date()}`, 'background: #222; color: #bada55');
      render(<Root store={store} />, document.getElementById('root'));
    });
  }
} else {
  console.ignoredYellowBox = ['Setting a timer'];
  setDefaultLang(I18nManager.isRTL ? 'ar' : 'en');
  const App = () => <Root store={store} />;
  const LoadedApp = () => <LoadAssets App={App} />;
  Expo.registerRootComponent(LoadedApp);
}



// WEBPACK FOOTER //
// ./src/index.js